import Vue from 'vue';
import wx from '@/libs/jsweixin-1.6.0';

const install = () => {
  Vue.prototype.$wechat = wx;
};

Vue.use(install);
